import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { MantineProvider, createTheme, Modal } from '@mantine/core'
import "@mantine/core/styles.css";

const theme = createTheme({
  components: {
    Modal: Modal.extend({
      defaultProps: {
        overlayProps: {
          backgroundOpacity: 0.55,
          blur: 3,
        },
      },
    }),
  },
});
import { BrowserRouter } from 'react-router-dom'
import '@mantine/carousel/styles.css';
import { Notifications } from '@mantine/notifications'
import "@mantine/notifications/styles.css"
import { LoaderProvider } from './Context/LoaderContext.jsx'

ReactDOM.createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
   <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <MantineProvider theme={theme}>
        <LoaderProvider>
          <Notifications position="top-right" containerWidth={350} style={{marginTop:'0rem', zIndex:'999', }}/>
          <App />
        </LoaderProvider>
      </MantineProvider>
    </BrowserRouter>
  // </React.StrictMode>,
)
